// AI Generated Pipe
import { Pipe, PipeTransform } from '@angular/core';
import { SessionService } from '@monsido/core/session/session.service';
import { ActiveFeatureService } from '@monsido/services/active-feature/active-feature.service';

@Pipe({
    name: 'hasAccess',
    standalone: false,
})
export class HasAccessPipe implements PipeTransform {
    private readonly MON_MODULES = {
        accessibility: 'accessibility',
        data_privacy: 'data_privacy',
        cookie_banner: 'cookie_banner',
        pagecorrect: 'pagecorrect',
    };

    constructor (
        private sessionService: SessionService,
        private activeFeatureService: ActiveFeatureService,
    ) {}

    transform (user: any, module: string): boolean {
        // If user is not set, no access should be granted, until a valid user exists
        if (!user || typeof user !== 'object') {
            return false;
        }

        let canAccessModule = true;

        switch (module) {
            case this.MON_MODULES.accessibility:
                canAccessModule = this.customerHasAccessToAccessibility();
                break;
            case this.MON_MODULES.data_privacy:
                canAccessModule = this.activeFeatureService.isFeatureActive(this.MON_MODULES.data_privacy);
                break;
            case this.MON_MODULES.cookie_banner:
                canAccessModule = this.activeFeatureService.isFeatureActive(this.MON_MODULES.cookie_banner);
                break;
            case this.MON_MODULES.pagecorrect:
                canAccessModule = this.customerHasAccessToPageCorrect();
                break;
        }

        // Users without any modules is allowed access to all modules in the migration period
        if (user && user.settings?.modules?.length > 0) {
            return canAccessModule && user.settings.modules.indexOf(module) === -1;
        }

        return canAccessModule;
    }

    private customerHasAccessToAccessibility (): boolean {
        const customer = this.sessionService.customer;
        return Boolean(!customer || customer.plan_traits?.accessibility);
    }

    private customerHasAccessToPageCorrect (): boolean {
        const customer = this.sessionService.customer;
        return Boolean(!customer || customer.plan_traits?.page_fix);
    }
}
